<template>
    <div class="container _container">
        <div class="containerbody _containerbody">
            <div class="content _content">
                <div class="content_left _content_left">
                    <el-card>
                        <div class="sideBar _sideBar">
                            <div class="head_title _head_title">{{$t('home.search')}}</div>
                           
                            <div class="divide_line _divide_line" ></div>
                            <div v-for="(item,index) in titleData.children" :key="index" :class="index == activeIndex?'navActive':'nav'" @click="subTitleClick(index)">{{item.title}}</div>
                            <el-form ref="form" :model="form">
                                <el-form-item :label="$t('home.name')">
                                    <el-input v-model="queryParams.personName"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('home.ageRange')">
                                    <div style="width: 100%;display: flex;">
                                        <el-input v-model="queryParams.minAge" style="width: 47%;"></el-input>&nbsp;-&nbsp;<el-input v-model="queryParams.maxAge" style="width: 47%;"></el-input>
                                    </div>
                                </el-form-item>
                                <!-- <el-form-item :label="$t('home.sex')">
                                    <el-select v-model="form.sex" placeholder="请选择" style="width: 100%;">
                                        <el-option
                                        v-for="item in sexOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item> -->
                            </el-form>
                            <el-button type="primary"  style="width: 100%;margin-top: 1em;" @click="search()">{{$t('home.search')}}</el-button>
                            <!-- <el-button type="primary" v-else style="width: 100%;margin-top: 1em;">chaxun</el-button> -->
                        </div>
                    </el-card>
                </div>
                <div class="content_right _content_right">
                    <el-card>
                        <div slot="header" style="text-align: left;font-size: 1.2em;">
                            <span v-if="$route.query.personStatus == '1'">{{$t('home.wantedPerson')}}</span>
                            <span v-else>{{$t('home.missingPerson')}}</span>

                        </div>

                        <div class="person_all _person_all">
                            <el-row>
                                <el-col :span="6" v-for="(item,index) in dataList" :key="index" style="margin:2em 0" >
                                    <!-- <div class="person_img" :style="{ backgroundImage: `url(${item.plugImage})` }" ></div> -->
                                    <div :class="$route.query.personStatus=='1'?'person_img_red _person_img_red':'person_img_yellow _person_img_yellow'"  @click="openDetail(item)"></div>
                                <!-- </img> -->
                                    <div class="person_text _person_text">
                                        <div style="color: #00437a;">
                                            <div style="width: 100%;">{{ item.personNum }}</div>
                                            <div style="width: 100%;">{{$t('home.caseNumber')}}</div>
                                            
                                        </div>
                                        <!-- <div style="color: #00437a;font-size: 0.9em;">
                                            {{ item.name }}
                                        </div> -->
                                    </div>
                                </el-col>
                            </el-row>
                            <!-- <div class="person_item" v-for="(item,index) in dataList" :key="index">
                                <img class="person_img" :style="{ backgroundImage: `url(${item.plugImage})` }"/>

                                <div class="person_text">
                                    {{ item.plugName }}
                                </div>
                            </div> -->
                        </div>
                        <div v-if="total==0" style="color: #CCCCCC;height: 30px">{{
                  $t('home.noData')
                  }}</div>
                        <!-- <div class="share_box">
                            <div class="share_img" @click="shareClick">
                                <img :src="imageUrl" width="40" height="40" />
                            </div>
                            <div class="share_img">
                                <img :src="imageUrl2" width="40" height="40" />
                            </div>
                        </div> -->
                        <el-row style="text-align: center;margin-top: 10px">
                            <!-- <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryParams.index"
                            :page-sizes="[10, 20, 30, 50]"
                            :page-size="queryParams.size"
                            layout="total, sizes, prev, pager, next"
                            :total="total">
                            </el-pagination> -->
                            <el-pagination
                                layout="prev, pager, next"
                                :total="total">
                            </el-pagination>
                        </el-row>
                    </el-card>

                </div>
            </div>
        </div>
        <!-- <shareDialog ref="shareDialog"></shareDialog> -->
    </div>
  </template>

  <script>
    // import shareDialog from './subcomponents/shareDialog'
    import {getContentList} from "@/api/navigation"
    import {getnewList, getcolumnsList, getplugList} from "../../api/resouces";
    import {getPersonRedYellowList} from "../../api/personRedYellow";

    import cookie from "js-cookie";
  export default {
    name: 'aboutUs',
    components: {
        // shareDialog
    },
    data(){
        return{
            form:{},
            imageUrl:require('@/components/aboutUs/imgs/facebook.png'),
            imageUrl2:require('@/components/aboutUs/imgs/Twitter.png'),
            // isThirdLevel:this.$route.query.isThirdLevel,
            pid:this.$route.query.pid,
            id:this.$route.query.id,
            total:0,//总数
            activeIndex:0,
            queryParams:{
                index:1,
                size:12,
            },
            titleTree:JSON.parse(sessionStorage.getItem('titleTree')),
            titleData:{},//标题内容
            titleDataChild:[{title:""}],
            contentList:[],//内容展示列表,
            flag:false,
            dataList:[{number:'',name:''}],
            dataListZh:[
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000001',
                    name:'张航',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000002',
                    name:'李凤杰',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000003',
                    name:'陈丽莎',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000004',
                    name:'何友',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000005',
                    name:'傅艺伟',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000006',
                    name:'冯伟',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000007',
                    name:'盛安',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000008',
                    name:'张宇',
                },
            ],
            dataListEn:[
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000001',
                    name:'ZHANGHANG',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000002',
                    name:'LIFENGJIE',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000003',
                    name:'CHENLISHA',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000004',
                    name:'HEYOU',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000005',
                    name:'FUYIWEI',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000006',
                    name:'FENGWEI',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000007',
                    name:'SHENGAN',
                },
                {
                    plugImage:'../../assets/img/red.png',
                    number:'0000008',
                    name:'ZHANGYU',
                },
            ],
            sexOptions:[
                {
                    label:"男",
                    value:0,
                },
                {
                    label:"女",
                    value:1,
                },
            ]
        }
    },
    created(){
    //     if(this.$i18n.locale == 'zh'){
    //         this.dataList = this.dataListZh
    //         }else if(this.$i18n.locale == 'en'){
    //         this.dataList = this.dataListEn
    //         }
    //    this.total = this.dataList.length
    },
    mounted(){
        // this.titleTree =
        // this.isThirdLevel = this.
        // this.pid = this.
        // this.id = this.$route.query.id
        // this.init()
        this.getData()
    },
    methods:{
        init(){
            this.flag = false //是否为二级标题
            this.titleTree.children.forEach((item,index) => {
                    if(item.data.id == this.id){
                        this.flag = true
                    }
            });
            if(this.flag){
                this.titleTree.children.forEach((item,index) => {
                    if(item.data.id == this.id){
                        this.titleData = item
                        this.titleDataChild = this.titleData.children
                        this.queryParams.classId = item.children[0].data.id
                        this.activeIndex = 0
                    }
                });
                this.getData()
            }else{
                this.titleTree.children.forEach((item,index) => {
                    if(item.data.id == this.pid){
                        this.titleData = item
                        this.titleDataChild = this.titleData.children

                        this.queryParams.classId = this.id
                        item.children.forEach((item2,index2)=>{
                            if(item2.data.id == this.id){
                                this.activeIndex = index2

                            }
                        })
                    }
                });
                this.getData()
            }
        },
        search(){
            this.queryParams.index="1"
            this.getData()
        },
        getData(){
            if(this.$i18n.locale == 'zh'){
                this.queryParams.lang="1"
            }else{
                this.queryParams.lang="2"
            }
            this.queryParams.personStatus = this.$route.query.personStatus
            getPersonRedYellowList(this.queryParams).then(res => {
                this.dataList = res.data;
                this.total = res.count
            })
            
        },
        shareClick(){
            this.$refs.shareDialog.open('Repost to Facebook',{})

        },
        subTitleClick(index){
            this.activeIndex = index
            this.queryParams.classId = this.titleData.children[index].data.id
            this.queryParams.index = 1
            this.queryParams.size = 10
            this.getData()
        },
        openDetail(item){
            this.$router.push({
              path: '/personDetail',
              query: {
                id:item.id,
                personStatus:this.$route.query.personStatus
              }
            })
            console.log("item",item)
        },
        /**页条数变化 */
        handleSizeChange(val){
          this.queryParams.size = val
          this.queryParams.index = 1
        //   this.pageList()
          this.getData()
        },
        /**当前页变化 */
        handleCurrentChange(val){
          this.queryParams.current = val
        //   this.pageList()

          this.getData()
        },
    }
  }
  </script>

  <style lang="less" scoped>

  // 大于800px
  @media only screen and (min-width: 800px){
      .container{
        width: 100%;
        overflow: hidden;
        .containerbody{
            width: 100%;
            min-height: 55.5vh;
            // max-width:1000px ;
            background-color: rgb(249, 249, 249);
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px 0;
            .content{
                width: 80%;
                margin: 0 auto;
                .content_left{
                    width: 20%;
                    float: left;
                    .sideBar{
                        text-align: left;
                        width: 100%;
                        .head_title{
                            padding: 0 0 20px 0;
                            color: rgba(51, 51, 51, 1);
                            font-family: SourceHanSansCN-Bold;
                            font-weight: 700;
                            font-size: 18px;
                            font-weight: bold;
                        }
                        .sub_title{
                            padding: 4px 0;
                            color: rgba(51, 51, 51, 1);
                            font-family: SourceHanSansCN-Regular;
                            font-size: 12px;

                        }
                        .divide_line{
                            width: 90%;
                            height: 1.5px;
                            margin:4px 0;
                            background-color: #2D52D0;
                        }
                        .nav{
                            overflow-wrap: break-word;
                            color: rgba(110, 110, 115, 1);
                            font-size: 12px;
                            font-family: SourceHanSansCN-Regular;
                            font-weight: normal;
                            white-space: nowrap;
                            line-height: 24px;
                            margin: 15px 0 10px 0;
                            cursor: pointer;
                        }
                        .nav:hover{
                            overflow-wrap: break-word;
                            color: #2D52D0;
                            font-size: 12px;
                            font-family: SourceHanSansCN-Regular;
                            font-weight: normal;
                            white-space: nowrap;
                            line-height: 24px;
                            margin: 15px 0 10px 0;
                            cursor: pointer;
                        }
                    } .navActive{
                            overflow-wrap: break-word;
                            color: #2D52D0;
                            font-size: 12px;
                            font-family: SourceHanSansCN-Regular;
                            font-weight: normal;
                            white-space: nowrap;
                            line-height: 24px;
                            margin: 15px 0 10px 0;
                            cursor: pointer;
                        }
                }
                .content_right{
                    width:78%;
                    float: right;
                    // margin-left: 3%;
                    .person_all{
                        width: 100%;
                        // display: flex;
                        // justify-content: center;
                        // align-items: center;
                        .person_img_red{
                                width: 8em;
                                height: 10em;
                                background-size: 100% 100%;
                                background-image: url(../../assets/img/red.png);
                                justify-content: center;
                                display: flex;
                        align-items: center;
                        text-align: center;
                        margin:0 auto;
                        cursor: pointer;
                            }
                            .person_img_yellow{
                                width: 8em;
                                height: 10em;
                                background-size: 100% 100%;
                                background-image: url(../../assets/img/yellow.png);
                                justify-content: center;
                                display: flex;
                        align-items: center;
                        text-align: center;
                        margin:0 auto;
                        cursor: pointer;
                            }
                            .person_img :hover{
                                width: 8em;
                                height: 10em;
                                background-size: 100% 100%;
                                background-image: url(../../assets/img/red.png);
                                justify-content: center;
                                display: flex;
                                align-items: center;
                                text-align: center;
                                margin:0 auto
                            }
                            .person_text{
                                margin-top: 1em;
                                font-size: 1em;
                                line-height: 2em;
                            }
                        .person_item{
                            width: 22%;
                            
                        }
                    }
                }
            }
        }
      }
  }

  // 小于800px
  @media only screen and (max-width: 800px){
    ._container{
        width: 100%;
        overflow: hidden;
        ._containerbody{
            width: 100%;
            min-height: 55.5vh;
            // max-width:1000px ;
            background-color: rgb(249, 249, 249);
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px 0;
            ._content{
                width: 95%;
                margin: 0 auto;
                ._content_left{
                    width: 100%;
                    // float: left;
                    ._sideBar{
                        text-align: left;
                        width: 100%;
                        ._head_title{
                            padding: 0 0 20px 0;
                            color: rgba(51, 51, 51, 1);
                            font-family: SourceHanSansCN-Bold;
                            font-weight: 700;
                            font-size: 18px;
                            font-weight: bold;
                        }
                        ._sub_title{
                            padding: 4px 0;
                            color: rgba(51, 51, 51, 1);
                            font-family: SourceHanSansCN-Regular;
                            font-size: 12px;

                        }
                        ._divide_line{
                            width: 100%;
                            height: 1.5px;
                            margin:4px 0;
                            background-color: #2D52D0;
                        }
                        ._nav{
                            overflow-wrap: break-word;
                            color: rgba(110, 110, 115, 1);
                            font-size: 12px;
                            font-family: SourceHanSansCN-Regular;
                            font-weight: normal;
                            white-space: nowrap;
                            line-height: 24px;
                            margin: 15px 0 10px 0;
                            cursor: pointer;
                        }
                        ._nav:hover{
                            overflow-wrap: break-word;
                            color: #2D52D0;
                            font-size: 12px;
                            font-family: SourceHanSansCN-Regular;
                            font-weight: normal;
                            white-space: nowrap;
                            line-height: 24px;
                            margin: 15px 0 10px 0;
                            cursor: pointer;
                        }
                    } ._navActive{
                            overflow-wrap: break-word;
                            color: #2D52D0;
                            font-size: 12px;
                            font-family: SourceHanSansCN-Regular;
                            font-weight: normal;
                            white-space: nowrap;
                            line-height: 24px;
                            margin: 15px 0 10px 0;
                            cursor: pointer;
                        }
                }
                ._content_right{
                    width:100%;
                    // float: right;
                    // margin-left: 3%;
                    margin-top: 1em;
                    ._person_all{
                        width: 100%;
                        // display: flex;
                        // justify-content: center;
                        // align-items: center;
                        ._person_img_red{
                                width: 4em;
                                height: 5em;
                                background-size: 100% 100%;
                                background-image: url(../../assets/img/red.png);
                                justify-content: center;
                                display: flex;
                        align-items: center;
                        text-align: center;
                        margin:0 auto;
                        cursor: pointer;
                            }
                            ._person_img_yellow{
                                width: 4em;
                                height: 5em;
                                background-size: 100% 100%;
                                background-image: url(../../assets/img/yellow.png);
                                justify-content: center;
                                display: flex;
                        align-items: center;
                        text-align: center;
                        margin:0 auto;
                        cursor: pointer;
                            }
                            ._person_img :hover{
                                width: 8em;
                                height: 10em;
                                background-size: 100% 100%;
                                background-image: url(../../assets/img/red.png);
                                justify-content: center;
                                display: flex;
                                align-items: center;
                                text-align: center;
                                margin:0 auto
                            }
                            ._person_text{
                                margin-top: 1em;
                                font-size: 14px;
                                line-height: 2em;
                            }
                        ._person_item{
                            width: 22%;
                            
                        }
                    }
                }
            }
        }
      }
  }
  </style>



// WEBPACK FOOTER //
// src/components/page/personNotice.vue